import { render, staticRenderFns } from "./RegisterNewReturning.vue?vue&type=template&id=10939ea7&scoped=true"
import script from "./RegisterNewReturning.vue?vue&type=script&lang=js"
export * from "./RegisterNewReturning.vue?vue&type=script&lang=js"
import style0 from "./RegisterNewReturning.vue?vue&type=style&index=0&id=10939ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10939ea7",
  null
  
)

export default component.exports